var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.999,
    height: 31,
    viewBox: "0 0 18.999 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mouse.svg",
    transform: "translate(-40.484 -34.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_256",
    "data-name": "\\uD328\\uC2A4 256",
    d: "M49.984,65.553a9.511,9.511,0,0,1-9.5-9.5v-12a9.5,9.5,0,1,1,19,0v12A9.51,9.51,0,0,1,49.984,65.553Zm0-29.5a8.009,8.009,0,0,0-8,8v12a8,8,0,1,0,16,0v-12A8.008,8.008,0,0,0,49.984,36.053Z",
    fill: "#bbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_257",
    "data-name": "\\uD328\\uC2A4 257",
    d: "M49.984,48.75a.75.75,0,0,1-.75-.75V41a.75.75,0,0,1,1.5,0v7A.75.75,0,0,1,49.984,48.75Z",
    fill: "#bbb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouse);
export default __webpack_public_path__ + "static/media/mouse.5d7829a783e16fca14a5599028d134db.svg";
export { ForwardRef as ReactComponent };